import Wrapper from "../assets/wrappers/How";
import how from "../assets/images/how.png";
const How = () => {
  return (
    <Wrapper name="how">
      <div className="container">
        <div className="left">
          <h3>Your Journey to Recovery</h3>
          <div className="list-container">
            <div className="item" data-aos="fade-right">
              <div className="number">1</div>
              <div className="content">
                <h4>Initial Consultation</h4>
                <p>
                  We start with a comprehensive assessment to understand your condition and medical history.
                </p>
              </div>
            </div>
            <div className="item" data-aos="fade-right">
              <div className="number">2</div>
              <div className="content">
                <h4>Personalized Care Plan</h4>
                <p>
                  We design a tailored treatment program focused on your specific recovery goals and needs.
                </p>
              </div>
            </div>
            <div className="item" data-aos="fade-right">
              <div className="number">3</div>
              <div className="content">
                <h4>Active Therapy</h4>
                <p>
                  Engage in hands-on manual therapy and guided exercises to restore function and strength.
                </p>
              </div>
            </div>
            <div className="item" data-aos="fade-right">
              <div className="number">4</div>
              <div className="content">
                <h4>Long-term Wellness</h4>
                <p>Learn maintenance strategies to prevent future injuries and maintain your health.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="right" data-aos="zoom-in">
          <img className="image" src={how} alt="Patient journey flowchart showing consultation, care plan, active therapy, and wellness stages" />
        </div>
      </div>
    </Wrapper>
  );
};

export default How;
